import styled, { css, keyframes } from 'styled-components';

const appear = keyframes`
from {
  opacity: 1;
}
to {
  opacity: 0;
}`;

export const ImageWrapper = styled.span<any>`
  box-sizing: border-box;
  display: block;
  overflow: hidden;
  width: initial;
  height: initial;
  background: none;
  opacity: 1;
  border: 0px;
  margin: 0px;
  padding: 0px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  ${({ contain }) =>
    contain &&
    css`
      img {
        object-fit: contain !important;
      }
    `}
  img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    box-sizing: border-box;
    padding: 0px;
    border: none;
    margin: auto;
    display: block;
    width: 0px;
    height: 0px;
    min-width: 100%;
    max-width: 100%;
    min-height: 100%;
    max-height: 100%;
    object-fit: cover;
    z-index: 1;
    /* :first-of-type {
      background-color: #fff;
    } */
    &.thumb {
      position: absolute !important;
      z-index: 0;
      top: 0;
      left: 0;
      /* opacity: 0;
      animation: ${appear} 5s ease; */
    }
  }
`;
